import $ from 'jquery'

$(document).ready(function () {
    $('.icons .search-button').click(function(){
        $('.header .search-container').toggle();
        if($('#menu-button').hasClass('active')) {          
            $('#menu-button').click()
        }
        return false;
    });
    $('.search-container .close').click(function(){
        $('.header .search-container').hide();
        return false;
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/partials/search.js